<div *ngIf="!data.isDelete">
  <mat-dialog-content>
    <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
      <div class="row">
        <div class="col-12" *ngIf="!data.isEdit">
          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}" floatLabel="{{ formFieldFloatLabel }}">
            <mat-label class="InputLabelColor">Híbrido</mat-label>
            <mat-select #txtHibrido formControlName="pc_hibrido" disableCenteringOption>
              <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                (keyup)="createFilterHibrido($event.target.value)" />
              <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                {{ item.name | uppercase }}
              </mat-option>
            </mat-select>
            <i matSuffix class="{{ iconEnableField }}"></i>
            <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12" *ngIf="data.isEdit">
          Híbrido - {{data.pc003.pc_hibrido}}
        </div>
        <div class="col-12 mt-3">
          <label for="">Comentário</label>
          <ckeditor formControlName="comment"></ckeditor>
          <!-- <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
            <mat-label class="InputLabelColor">Comentário</mat-label>
            <textarea matInput id="txtComment" #txtComment maxlength="255" formControlName="comment"></textarea>
           
            <i matSuffix class="{{iconEnableField}}"></i>
            <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
            <mat-hint align="end">{{txtComment.value.length}} / 255</mat-hint>

          </mat-form-field> -->

        </div>
      </div>
    </form>

  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-raised-button color="primary" (click)="closeModal()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="saveConfirm($event)">Salvar</button>

  </mat-dialog-actions>
</div>
<div *ngIf="data.isDelete">
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content>{{data.mensage}}</div>
  <mat-dialog-actions align="center" class="mt-3">
    <button mat-button [mat-dialog-close]="false" class="mr-2">{{data.titleBtn1}}</button>
    <button mat-button color="primary" cdkFocusInitial (click)="saveConfirm($event)">{{data.titleBtn2}}</button>
  </mat-dialog-actions>
</div>